/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getAppBannerTable = params => {
  return axios.post(`${base}/app_banner/query`, params)
}
export const getAppBannerDetail = params => {
  return axios.get(`${base}/app_banner/get_${params.id}`, {params})
}
export const exportAppBannerData = params => {
  return axios.get(`${base}/exportAppBannerData/${params.id}`, {params})
}
export const createAppBannerData = params => {
  return axios.post(`${base}/app_banner/create`, params)
}
export const updateAppBannerData = params => {
  return axios.post(`${base}/app_banner/edit_${params.id}`, params)
}
export const deleteAppBannerData = params => {
  return axios.post(`${base}/app_banner/delete_${params.id}`, params)
}
export const getAppBannerLogs = params => {
  return axios.post(`${base}/app_banner/op_logs_${params.id}`, params)
}

export const uploadAppBanner = params => {
  return axios.post(`${base}/app_banner/upload`, params)
}



// WEBPACK FOOTER //
// ./src/views/app-banner/app-banner.api.js